import { AreaChart, ChartEmpty } from "../Charts";
import { bucketLabel, fillSeries, fmtInt, type Stats } from "../../web-analytics";

/** "America/Los_Angeles" → "Pacific time" where the browser knows a generic name. */
function zoneName(zone: string): string {
  try {
    const part = new Intl.DateTimeFormat("en-US", { timeZone: zone, timeZoneName: "longGeneric" })
      .formatToParts(new Date())
      .find((p) => p.type === "timeZoneName")?.value;
    return part ? part.replace(/ Time$/, " time") : zone;
  } catch {
    return zone;
  }
}

/** Counts are whole numbers; a half-way gridline (2.5 visitors) keeps its line but not its label. */
const countLabel = (v: number) => (Number.isInteger(v) ? fmtInt(v) : "");

/** Visitors per hour (today, short custom ranges) or per day, zero-filled and clipped at now. */
export default function TrafficChart({ stats, emptyReason }: { stats: Stats; emptyReason?: string }) {
  const { bucket, tz } = stats.range;
  const points = fillSeries(stats.timeseries, stats.range);
  // An hourly custom range can cross midnight; "1 PM" twice would be ambiguous.
  const multiDay = bucket === "hour" && points.length > 0 && points[0].bucket.slice(0, 10) !== points[points.length - 1].bucket.slice(0, 10);
  const data = points.map((p) => ({
    label: multiDay ? `${bucketLabel(p.bucket, "day")}, ${bucketLabel(p.bucket, "hour")}` : bucketLabel(p.bucket, bucket),
    value: p.visitors,
  }));
  const empty = stats.totals.visitors === 0;
  return (
    <section className="panel chart-card wa-chart">
      <div className="panel-heading">
        <div>

          <h2>Visitors over time</h2>
        </div>
        <span className="panel-meta">{bucket === "hour" ? "By hour" : "By day"} · {zoneName(tz)}</span>
      </div>
      <div className="chart-body">
        {empty ? (
          <ChartEmpty>{emptyReason || "No visits in this range."}</ChartEmpty>
        ) : (
          <AreaChart integer data={data} format={countLabel} caption={`Visitors ${bucket === "hour" ? "per hour" : "per day"}`} height={220} />
        )}
      </div>
    </section>
  );
}
